import { EMPTY_DIRECT_DATA_INPUT_SEARCH_CRITERIA } from "domain/entity/DirectDataInput/DirectDataInputSearchCriteria";
import { getDefaultBuConfig } from "domain/repository/apiUtil";
import moment from "moment";
import { useDirectDataInputVM } from "presentation/hook/DirectDataInput/useDirectDataInputVM";
import { useDirectDataInputTracked } from "presentation/store/DirectDataInput/DirectDataInputProvider";
import { memo, useEffect, useState } from "react";
import { Loader, SliderPanel } from "veronica-ui-component/dist/component/core";
import DirectDataInputEditPanel from "./DirectDataInputEditPanel";
import DirectDataInputSearchPanel from "./DirectDataInputSearchPanel";
import DirectDataInputTablePanel from "./DirectDataInputTablePanel";
import DirectDataInputTitleBar from "./DirectDataInputTitleBar";

const DirectDataInputMaintenance: React.FC = () => {
    const [directDataInputState] = useDirectDataInputTracked();
    const directDataInputVM = useDirectDataInputVM();
    const [isLoading, setIsLoading] = useState(true);
    const { isShowSearchPanel, isShowEditPanel } = directDataInputState;

    useEffect(() => {
        directDataInputVM.setIsSearchLoading(true);
        const initialScreen = async () => {
            setIsLoading(true);
            await Promise.allSettled([
                directDataInputVM.loadDropdownOption(),
            ]);
        };

        initialScreen().then((data) => {
            let newSearchCriteria = { ...EMPTY_DIRECT_DATA_INPUT_SEARCH_CRITERIA }
            newSearchCriteria = {
                ...newSearchCriteria,
                opsDateFrom: moment().subtract(getDefaultBuConfig("REACT_APP_SEARCH_DATA_DEFAULT_DATE_RANGE"), "days").startOf("day").toDate(),
                opsDateTo: moment().startOf("day").toDate(),
            };
            directDataInputVM.onSearch(newSearchCriteria).then((data) => {
                setIsLoading(false);
                directDataInputVM.setIsSearchLoading(false);
            }).catch(error => {
                setIsLoading(false);
                directDataInputVM.setIsSearchLoading(false);
            });
        }).catch(error => {
            setIsLoading(false);
            directDataInputVM.setIsSearchLoading(false);
        });
    }, [directDataInputVM]);

    if (isLoading) return <Loader Indicator="Stripe" size="Large" />;

    return <>
        <div className={`main-comp-wrapper${isShowSearchPanel ? '' : ' im-hide-side-form-draggable'}`}>
            {isShowEditPanel && <DirectDataInputEditPanel />}

            {!isShowEditPanel && <>
                <DirectDataInputTitleBar />
                <SliderPanel
                    isOpen={true}
                    draggable={false}
                    leftSectionWidth={isShowSearchPanel ? "30%" : "0%"}
                    rightSectionWidth={isShowSearchPanel ? "70%" : "100%"}
                    leftChildren={<DirectDataInputSearchPanel />}
                    rightChildren={<DirectDataInputTablePanel />}
                /></>}
        </div>
    </>
}

export default memo(DirectDataInputMaintenance);